import Component from '../core/Component'
import throttle from 'lodash/throttle'

export default class Progress extends Component {
    constructor($element) {
        super($element)

        this.ref = {
            progressBar: null,
            sections: [],
            sectionLinks: []
        }

        this.sections = this.ref.sections;
        this.sectionLinks = this.ref.sectionLinks;
        this.resize();

        this.scrollHandler = throttle(::this.scroll);
        this.resizeHandler = throttle(::this.resize);
    }

    prepare() {

        window.addEventListener('scroll', this.scrollHandler);
        window.addEventListener('resize', this.resizeHandler);
        new ResizeObserver(::this.resizeHandler).observe(this.element)

        this.scroll();
    }

    destroy() {
        window.removeEventListener('scroll', this.scrollHandler)
        window.removeEventListener('resize', this.resizeHandler);
    }

    resize(event) {
        let body = document.body,
            html = document.documentElement;

        // length
        this.elementHeight = this.element.offsetHeight;

        // start
        let rect = this.element.getBoundingClientRect();
        this.top = rect.top + window.pageYOffset;
        this.windowHeight = window.innerHeight;

        //items
        this.borders = [];
        this.sections.forEach(item => {
            let rect = item.getBoundingClientRect();
            this.borders.push({
                top: rect.top + window.pageYOffset,
                bottom: rect.top + window.pageYOffset + item.offsetHeight
            });
        });
    }

    scroll () {
        this.progress = (window.pageYOffset - this.top + (this.windowHeight/2)) / this.elementHeight;
        if (this.progress >= 0 && this.progress <= 1) {
            this.ref.progressBar.style.height = this.progress*100 + '%';
        }

        this.borders.forEach((item, index) => {
            // is in viewport
            if (item.top < window.pageYOffset + (this.windowHeight/2) && item.bottom > window.pageYOffset + (this.windowHeight/2)) {
                this.sectionLinks[index].classList.add('is-active');
            } else {
                this.sectionLinks[index].classList.remove('is-active');
            }
        });
    }
}


// WEBPACK FOOTER //
// ./components/Progress.js